import React from "react";
import { useNavigate } from "react-router-dom";
import { RiTaskLine } from "react-icons/ri";
import { useAuth } from "../../context/AuthContext";
import Sidebar from "../../components/Sidebar/Sidebar";
import MobileHeader from "../../components/MobileHeader/MobileHeader";
import WeeklySnapshot from "../../components/WeeklySnapshot/WeeklySnapshot";
import WorkoutFeed from "../../components/WorkoutFeed/WorkoutFeed";
import Fab from "../../components/Fab/Fab";
import BottomNav from "../../components/BottomNav/BottomNav";
import Footer from "../../components/Footer/Footer";
import "./Home.css";

const Home = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const firstName = user?.name?.split(" ")[0] || "there";

  return (
    <div className="page-layout">
      <Sidebar hideMobileBottomNav />
      <MobileHeader />

      <main className="page-content home-content">
        <div className="page-header">
          <div>
            <h1 className="page-title">Hey, {firstName}</h1>
            <p className="page-subtitle">Here's what's happening this week.</p>
          </div>
          <button
            type="button"
            className="btn btn-ghost home-daily-log-link"
            onClick={() => navigate("/daily-log")}
          >
            <RiTaskLine size={16} />
            Daily Log
          </button>
        </div>

        <WeeklySnapshot />
        <WorkoutFeed />
        <Footer />
      </main>

      <Fab onClick={() => navigate("/exercises")} />
      <BottomNav />
    </div>
  );
};

export default Home;
